import { vec3 } from 'gl-matrix';
import { NavigationSystem, VolumeGridLike } from '../navigation-mesh';
import { TickEventManager } from '../util';
import { PhysicsBody, PhysicsFeature } from '../physics';
import { NavigationAwareObject } from './NavigationAwareObject';

export interface NavigationObjectDeps {
  navigation: NavigationSystem;
  volumeGrid: VolumeGridLike | null;
  tickEventManager: TickEventManager;
  physics?: PhysicsFeature;
}

export function createNavigationAwareObject(
  deps: NavigationObjectDeps,
  obj: { position: vec3 | number[] },
  speed: number,
): NavigationAwareObject {
  // TODO: keep track of nav objects and dispose them when required
  let nav = new NavigationAwareObject(obj, deps, speed);

  deps.tickEventManager.registerFrameEvent(() => {
    nav.movement.step();
  });

  // Initialize entity position to correct floor height
  if (nav.movement.currentNode?.node && deps.volumeGrid) {
    let nodeMaxY = nav.movement.currentNode.node.max[1] as number;
    let h = deps.volumeGrid.getFloorHeightBelow(
      obj.position[0] as number,
      nodeMaxY,
      obj.position[2] as number,
    );
    if (h !== null) {
      obj.position[1] = h;
    }
  }

  if (deps.physics) {
    let body = new PhysicsBody(obj.position, { mode: 'gravity-only' });
    body.surfaceHeight = obj.position[1] as number;
    body.minFloorHeight = obj.position[1] as number;
    body.grounded = true;
    nav.physicsBody = body;
    deps.physics.addBody(body);
  }

  return nav;
}
